import React, { useState, useEffect } from "react";
import InputField from "../../input-field/InputField";
import DefaultButton from "../../default-button/DefaultButton";
import Cross from "../../../assets/icons/Cross";
import DocumentTable from "../DocumentTable/DocumentTable";
import { categories, documents, socialTranscriptItemStatuses } from "../../../misc/constants";
import { useHookstate } from "@hookstate/core";
import { useUniversalFind, useUniversalFindAll } from "../../../hooks/universal";
import { SocialCategory, SocialSubcategory, SocialTranscriptItem } from "../../../types";
import { onInputChangeNative } from "../../../misc/utils";
import { useGlobalMiscState } from "../../../stores/misc";

interface Document {
  id: number;
  profile: string;
  name: string;
  category: string;
  item: string;
  uploadTime: string;
  doc: string;
  status: string;
}

export default function DocumentPage() {
  const miscState = useGlobalMiscState();
  const socialTranscriptItemsTriggerFetch = miscState.get('socialTranscriptItemsTriggerFetch');
  const socialCategories: SocialCategory[] = useUniversalFindAll('SocialCategory')
  const socialSubcategories: SocialSubcategory[] = useUniversalFindAll('SocialSubcategory')
  const allTranscriptItems: SocialTranscriptItem[] = useUniversalFind('SocialTranscriptItem', {}, {
    include: [{
      model: 'SocialSubcategory',
      as: 'social_subcategory',
      include: ['social_category']
    },
      'main_user', 'media']
  }, socialTranscriptItemsTriggerFetch)
  const localState = useHookstate({
    searchText: "",
    category: "",
    subcategory: "",
    status: ""
  });
  const state = localState.get();
  const { searchText, category, subcategory, status } = state;

  // const applyFilters = () => {
  //   let filtered = documents;

  //   if (searchText) {
  //     filtered = filtered.filter((doc) =>
  //       doc.name.toLowerCase().includes(searchText.toLowerCase())
  //     );
  //   }

  //   if (category) {
  //     filtered = filtered.filter(
  //       (doc) => doc.category.trim().toLowerCase() === category.toLowerCase()
  //     );
  //   }

  //   if (item) {
  //     filtered = filtered.filter(
  //       (doc) => doc.item.trim().toLowerCase() === item.toLowerCase()
  //     );
  //   }

  //   setFilteredDocuments(filtered);
  // };

  // useEffect(() => {
  //   applyFilters();
  // }, [searchText, category, item]);

  const transcriptItems = allTranscriptItems.filter(item => {
    let retValue = true;
    if (searchText) {
      retValue = retValue &&
        (item.social_subcategory.name.toLowerCase().includes(searchText.toLowerCase()) ||
          item.social_subcategory.social_category?.name.toLowerCase().includes(searchText.toLowerCase()) ||
          item.main_user.json_saved_data.firstname.toLowerCase().includes(searchText.toLowerCase()) ||
          item.main_user.json_saved_data.lastname.toLowerCase().includes(searchText.toLowerCase()) ||
          Boolean(item.media.find(m => m.filename?.toLowerCase().includes(searchText.toLowerCase())))
        );
    }

    if (category) {
      retValue = retValue &&
        item.social_subcategory.social_category?.id === parseInt(category)
    }

    if (subcategory) {
      retValue = retValue &&
        item.social_subcategory.id === parseInt(subcategory)
    }

    if (status) {
      retValue = retValue &&
        item.status === parseInt(status)
    }

    return retValue;
  })

  const deleteDocument = (id: number) => {
    // setFilteredDocuments((prev) => prev.filter((doc) => doc.id !== id));
  };

  return (
    <div className="bg-white py-2 px-4 rounded-xl w-full mt-4 min-h-screen overflow-x-hidden">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 pl-2 pr-[22px] pt-2 pb-6">
        <InputField
          type="text"
          placeholder="Поиск"
          value={searchText}
          handleChange={onInputChangeNative(localState, 'searchText')}
          wrapperClassName="min-w-0"
        />
        <div className="flex items-center gap-2 min-w-0">
          <label htmlFor="category" className="text-sm text-gray-700 whitespace-nowrap">
            Категория
          </label>
          <select
            id="category"
            className="border border-gray-200 rounded-md p-2 w-full focus:outline-none bg-blue-100 opacity-[0.4] text-black"
            value={category}
            onChange={onInputChangeNative(localState, 'category')}
          >
            <option value="" selected>
              Все
            </option>
            {socialCategories.map((c) => (
              <option value={c.id}>{c.name}</option>
            ))}
          </select>
        </div>
        <div className="flex items-center gap-2 min-w-0">
          <label htmlFor="subcategory" className="text-sm text-gray-700 whitespace-nowrap">
            Пункт
          </label>
          <select
            id="subcategory"
            className="border border-gray-200 rounded-md p-2 w-full focus:outline-none bg-blue-100 opacity-[0.4] text-black"
            value={subcategory}
            onChange={onInputChangeNative(localState, 'subcategory')}
          >
            <option value="" selected>
              Все
            </option>
            {socialSubcategories
              .map((c) => (
                <option value={c.id}>{c.name}</option>
              ))}
          </select>
        </div>
        <div className="flex items-center gap-2 min-w-0">
          <label htmlFor="status" className="text-sm text-gray-700 whitespace-nowrap">
            Статус
          </label>
          <select
            id="status"
            className="border border-gray-200 rounded-md p-2 w-full focus:outline-none bg-blue-100 opacity-[0.4] text-black"
            value={status}
            onChange={onInputChangeNative(localState, 'status')}
          >
            <option value="" selected>
              Все
            </option>
            {socialTranscriptItemStatuses
              .map((c) => (
                <option value={c.value}>{c.label}</option>
              ))}
          </select>
        </div>
      </div>
      <DocumentTable
        searchQuery={searchText}
        documents={transcriptItems}
        onDelete={deleteDocument}
      />
    </div>
  );
}
